export default __webpack_public_path__ + "static/media/fb.db9e2044.svg";